
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("kwtxh", function(module, exports) {

$parcel$export(module.exports, "BrowserTracing", function () { return $ef0db4fa300d72c6$export$46d3bbd0375f5fa4; });

var $jQ7br = parcelRequire("jQ7br");
var $9XIX6 = parcelRequire("9XIX6");
var $cumZG = parcelRequire("cumZG");
var $eZNqW = parcelRequire("eZNqW");
var $9NpO5 = parcelRequire("9NpO5");
var $4jmKj = parcelRequire("4jmKj");
var $iJuzX = parcelRequire("iJuzX");
var $epGyk = parcelRequire("epGyk");
var $6oOQO = parcelRequire("6oOQO");
var $25Qdw = parcelRequire("25Qdw");
var $lWUU2 = parcelRequire("lWUU2");
var $dud9P = parcelRequire("dud9P");
var $bDAMw = parcelRequire("bDAMw");
var $6uyRZ = parcelRequire("6uyRZ");
var $d8S4K = parcelRequire("d8S4K");
var $449X2 = parcelRequire("449X2");
var $hpBQ7 = parcelRequire("hpBQ7");
var $d4hcq = parcelRequire("d4hcq");
var $eDxfj = parcelRequire("eDxfj");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ const $ef0db4fa300d72c6$export$46d3bbd0375f5fa4 = (0, $cumZG.BrowserTracing);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $ef0db4fa300d72c6$export$5a20b45239a3c0a6 = (0, $jQ7br.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $ef0db4fa300d72c6$export$a7feb32fdd923295 = (0, $iJuzX.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $ef0db4fa300d72c6$export$8e9a29865c0a1226 = (0, $4jmKj.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $ef0db4fa300d72c6$export$ac65c70d78fcdb55 = (0, $d8S4K.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $ef0db4fa300d72c6$export$febc5573c75cefb0 = (0, $eDxfj.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $ef0db4fa300d72c6$export$5f1714a13ed34c01 = (0, $d8S4K.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $ef0db4fa300d72c6$export$bbd2089f30bd3708 = (0, $cumZG.BROWSER_TRACING_INTEGRATION_ID);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $ef0db4fa300d72c6$export$cc17fb3c0bc95cd7 = (0, $eZNqW.defaultRequestInstrumentationOptions);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $ef0db4fa300d72c6$export$5008da00b1b6dee6 = (0, $6oOQO.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $ef0db4fa300d72c6$export$ce084c78234bd35 = (0, $d4hcq.stripUrlQueryAndFragment);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $ef0db4fa300d72c6$export$394a210812ba3012 = (0, $4jmKj.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $ef0db4fa300d72c6$export$b279e6bd7040371f = (0, $25Qdw.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $ef0db4fa300d72c6$export$864489cb3478db3e = (0, $eZNqW.instrumentOutgoingRequests);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $ef0db4fa300d72c6$export$479dbd817e392a4f = (0, $hpBQ7.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $ef0db4fa300d72c6$export$beb8e6a823e89c5d = (0, $449X2.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $ef0db4fa300d72c6$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $ef0db4fa300d72c6$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $9XIX6.Apollo),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $9NpO5.Express),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $epGyk.GraphQL),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $lWUU2.Mongo),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $dud9P.Mysql),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $bDAMw.Postgres),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $6uyRZ.Prisma)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $jQ7br.addExtensionMethods)();

});
parcelRegister("jQ7br", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", function () { return addExtensionMethods; });

var $hpBQ7 = parcelRequire("hpBQ7");
var $qxdOb = parcelRequire("qxdOb");

var $1ZrrS = parcelRequire("1ZrrS");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $qxdOb.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $1ZrrS.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $1ZrrS.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $1ZrrS.dynamicRequire)(module, "./node/integrations/mysql");
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $1ZrrS.dynamicRequire)(module, "./node/integrations/postgres");
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $1ZrrS.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $hpBQ7.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $1ZrrS.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("hpBQ7", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $cad21fa2d3166c04$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $cad21fa2d3166c04$export$653d0ef2bad9cdf9; });

var $f6lSX = parcelRequire("f6lSX");
var $d6uqj = parcelRequire("d6uqj");

var $qxdOb = parcelRequire("qxdOb");

var $6oOQO = parcelRequire("6oOQO");

var $5D9Ow = parcelRequire("5D9Ow");

var $25Qdw = parcelRequire("25Qdw");

var $eDxfj = parcelRequire("eDxfj");
/** Returns all trace headers that are currently on the top scope. */ function $cad21fa2d3166c04$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $cad21fa2d3166c04$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $6oOQO.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$cad21fa2d3166c04$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $cad21fa2d3166c04$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $f6lSX.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $cad21fa2d3166c04$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $eDxfj.Transaction)(transactionContext, this);
    transaction = $cad21fa2d3166c04$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $cad21fa2d3166c04$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $25Qdw.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $cad21fa2d3166c04$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $cad21fa2d3166c04$export$653d0ef2bad9cdf9() {
    const carrier = (0, $qxdOb.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $cad21fa2d3166c04$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $cad21fa2d3166c04$var$traceHeaders;
    (0, $5D9Ow.registerErrorInstrumentation)();
}

});
parcelRegister("6oOQO", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $4a8c6ddf80e2b85d$export$5008da00b1b6dee6; });

var $qxdOb = parcelRequire("qxdOb");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $4a8c6ddf80e2b85d$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $qxdOb.getCurrentHub)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});

parcelRegister("5D9Ow", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $4198351b7ad03af7$export$637857c1d87b640c; });

var $a4dim = parcelRequire("a4dim");
var $d6uqj = parcelRequire("d6uqj");

var $iJuzX = parcelRequire("iJuzX");
let $4198351b7ad03af7$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $4198351b7ad03af7$export$637857c1d87b640c() {
    if ($4198351b7ad03af7$var$errorsInstrumented) return;
    $4198351b7ad03af7$var$errorsInstrumented = true;
    (0, $a4dim.addInstrumentationHandler)("error", $4198351b7ad03af7$var$errorCallback);
    (0, $a4dim.addInstrumentationHandler)("unhandledrejection", $4198351b7ad03af7$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $4198351b7ad03af7$var$errorCallback() {
    const activeTransaction = (0, $iJuzX.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$4198351b7ad03af7$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRegister("iJuzX", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $da342648d20f41cb$export$a7feb32fdd923295; });

var $qxdOb = parcelRequire("qxdOb");

/** Grabs active transaction off scope, if any */ function $da342648d20f41cb$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $qxdOb.getCurrentHub)();
    const scope = hub.getScope();
    return scope.getTransaction();
}

});


parcelRegister("25Qdw", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $18648da59a228e4a$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $18648da59a228e4a$export$b279e6bd7040371f; });

var $d6uqj = parcelRequire("d6uqj");
var $9rjmL = parcelRequire("9rjmL");

var $d8S4K = parcelRequire("d8S4K");

var $eDxfj = parcelRequire("eDxfj");
const $18648da59a228e4a$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $18648da59a228e4a$var$FINISH_REASON_TAG = "finishReason";
const $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $18648da59a228e4a$export$370d6113c18ba86c extends (0, $d8S4K.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $9rjmL.timestampInSeconds)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $18648da59a228e4a$export$b279e6bd7040371f extends (0, $eDxfj.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $18648da59a228e4a$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $18648da59a228e4a$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $18648da59a228e4a$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $9rjmL.timestampInSeconds)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === "ui.action.click") this.setTag($18648da59a228e4a$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus("cancelled");
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = span.endTimestamp - this.startTimestamp < timeoutWithMarginOfError;
                if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $d6uqj.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $d6uqj.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] flushing IdleTransaction");
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $18648da59a228e4a$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $9rjmL.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus("deadline_exceeded");
            this._finishReason = $18648da59a228e4a$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("d8S4K", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $9915f8069579900f$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $9915f8069579900f$export$5f1714a13ed34c01; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $9915f8069579900f$export$ac65c70d78fcdb55; });

var $btSxb = parcelRequire("btSxb");
var $4jmKj = parcelRequire("4jmKj");
var $d6uqj = parcelRequire("d6uqj");
var $9rjmL = parcelRequire("9rjmL");
var $8YQXS = parcelRequire("8YQXS");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $9915f8069579900f$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $9915f8069579900f$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ /**
   * The origin of the span, giving context about what created the span.
   */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this.traceId = spanContext.traceId || (0, $8YQXS.uuid4)();
        this.spanId = spanContext.spanId || (0, $8YQXS.uuid4)().substring(16);
        this.startTimestamp = spanContext.startTimestamp || (0, $9rjmL.timestampInSeconds)();
        this.tags = spanContext.tags || {};
        this.data = spanContext.data || {};
        this.instrumenter = spanContext.instrumenter || "sentry";
        this.origin = spanContext.origin || "manual";
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.name) this.description = spanContext.name;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    /** An alias for `description` of the Span. */ get name() {
        return this.description || "";
    }
    /** Update the name of the span. */ set name(name) {
        this.setName(name);
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $9915f8069579900f$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = childSpan.transaction.name || "< unknown name >";
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $d6uqj.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        this.setData("http.response.status_code", httpStatus);
        const spanStatus = $9915f8069579900f$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ setName(name) {
        this.description = name;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === "ok";
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $d6uqj.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $9rjmL.timestampInSeconds)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        return (0, $4jmKj.generateSentryTraceHeader)(this.traceId, this.spanId, this.sampled);
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $btSxb.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $btSxb.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $btSxb.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
            origin: this.origin
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $9915f8069579900f$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}

});
parcelRegister("4jmKj", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", function () { return $323a94a2b54a033a$export$394a210812ba3012; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $323a94a2b54a033a$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $323a94a2b54a033a$export$ca5c066532785b6e; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $323a94a2b54a033a$export$f35d907436da45cf; });

var $i0l4v = parcelRequire("i0l4v");

var $8YQXS = parcelRequire("8YQXS");
const $323a94a2b54a033a$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $323a94a2b54a033a$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($323a94a2b54a033a$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 */ function $323a94a2b54a033a$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $323a94a2b54a033a$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $i0l4v.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    const propagationContext = {
        traceId: traceId || (0, $8YQXS.uuid4)(),
        spanId: (0, $8YQXS.uuid4)().substring(16),
        sampled: parentSampled
    };
    if (parentSpanId) propagationContext.parentSpanId = parentSpanId;
    if (dynamicSamplingContext) propagationContext.dsc = dynamicSamplingContext;
    return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext,
        propagationContext: propagationContext
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $323a94a2b54a033a$export$f35d907436da45cf(traceId = (0, $8YQXS.uuid4)(), spanId = (0, $8YQXS.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("i0l4v", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $d1b8928064b82a4f$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $d1b8928064b82a4f$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $d1b8928064b82a4f$export$56766feef403f365; });

var $f6lSX = parcelRequire("f6lSX");

var $d6uqj = parcelRequire("d6uqj");
const $d1b8928064b82a4f$export$9ca9946bd449ac06 = "baggage";
const $d1b8928064b82a4f$export$6e69537d67fa20f = "sentry-";
const $d1b8928064b82a4f$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $d1b8928064b82a4f$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $d1b8928064b82a4f$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $f6lSX.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $d1b8928064b82a4f$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $d1b8928064b82a4f$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($d1b8928064b82a4f$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($d1b8928064b82a4f$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $d1b8928064b82a4f$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$d1b8928064b82a4f$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $d1b8928064b82a4f$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $d1b8928064b82a4f$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $d1b8928064b82a4f$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $d1b8928064b82a4f$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});



parcelRegister("eDxfj", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $aa7e7f2ce2d4fd50$export$febc5573c75cefb0; });

var $btSxb = parcelRequire("btSxb");
var $d6uqj = parcelRequire("d6uqj");

var $qxdOb = parcelRequire("qxdOb");

var $kxUsJ = parcelRequire("kxUsJ");

var $d8S4K = parcelRequire("d8S4K");
/** JSDoc */ class $aa7e7f2ce2d4fd50$export$febc5573c75cefb0 extends (0, $d8S4K.Span) {
    /**
   * The reference to the current hub.
   */ /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        // We need to delete description since it's set by the Span class constructor
        // but not needed for transactions.
        delete this.description;
        this._measurements = {};
        this._contexts = {};
        this._hub = hub || (0, $qxdOb.getCurrentHub)();
        this._name = transactionContext.name || "";
        this.metadata = {
            source: "custom",
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = "custom") {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $d8S4K.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        const transaction = this._finishTransaction(endTimestamp);
        if (!transaction) return undefined;
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $btSxb.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $qxdOb.getCurrentHub)();
        const client = hub.getClient();
        if (!client) return {};
        const scope = hub.getScope();
        const dsc = (0, $kxUsJ.getDynamicSamplingContextFromClient)(this.traceId, client, scope);
        const maybeSampleRate = this.metadata.sampleRate;
        if (maybeSampleRate !== undefined) dsc.sample_rate = `${maybeSampleRate}`;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const source = this.metadata.source;
        if (source && source !== "url") dsc.transaction = this.name;
        if (this.sampled !== undefined) dsc.sampled = String(this.sampled);
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return transaction;
    }
}

});




parcelRegister("9XIX6", function(module, exports) {

$parcel$export(module.exports, "Apollo", function () { return $740c7e5928724c15$export$3db3e396472fda8d; });

var $9NUbC = parcelRequire("9NUbC");

var $8YQXS = parcelRequire("8YQXS");
var $btSxb = parcelRequire("btSxb");
var $f6lSX = parcelRequire("f6lSX");
var $1ZrrS = parcelRequire("1ZrrS");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
/** Tracing integration for Apollo */ class $740c7e5928724c15$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Apollo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = $740c7e5928724c15$export$3db3e396472fda8d.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $1ZrrS.loadModule)("@nestjs/graphql");
        else this._module = this._module || (0, $1ZrrS.loadModule)("apollo-server-core");
        return this._module;
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $b3hKh.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("Apollo Integration is skipped because of instrumenter configuration.");
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("Apollo-NestJS Integration was unable to require @nestjs/graphql package.");
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $btSxb.fill)(pkg.GraphQLFactory.prototype, "mergeWithSchema", function(orig) {
                return function(...args) {
                    (0, $btSxb.fill)(this.resolversExplorerService, "explore", function(orig) {
                        return function() {
                            const resolvers = (0, $8YQXS.arrayify)(orig.call(this));
                            const instrumentedResolvers = $740c7e5928724c15$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("Apollo Integration was unable to require apollo-server-core package.");
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $btSxb.fill)(pkg.ApolloServerBase.prototype, "constructSchema", function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                            if (this.config.schema) {
                                (0, $d6uqj.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $d6uqj.logger).warn();
                            } else if (this.config.modules) (0, $d6uqj.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.");
                            (0, $d6uqj.logger).error("Skipping tracing as no resolvers found on the `ApolloServer` instance.");
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $8YQXS.arrayify)(this.config.resolvers);
                    this.config.resolvers = $740c7e5928724c15$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$740c7e5928724c15$export$3db3e396472fda8d.__initStatic();
function $740c7e5928724c15$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== "function") return;
                $740c7e5928724c15$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $740c7e5928724c15$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
    (0, $btSxb.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            const scope = getCurrentHub().getScope();
            const parentSpan = scope.getSpan();
            const span = (0, $9NUbC._optionalChain)([
                parentSpan,
                "optionalAccess",
                (_2)=>_2.startChild,
                "call",
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: "graphql.resolve",
                        origin: "auto.graphql.apollo"
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $f6lSX.isThenable)(rv)) return rv.then((res)=>{
                (0, $9NUbC._optionalChain)([
                    span,
                    "optionalAccess",
                    (_4)=>_4.finish,
                    "call",
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, $9NUbC._optionalChain)([
                span,
                "optionalAccess",
                (_6)=>_6.finish,
                "call",
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}

});
parcelRegister("9NUbC", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", function () { return $7234461597845d83$export$3cc482e6b02f32f7; });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $7234461597845d83$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("b3hKh", function(module, exports) {

$parcel$export(module.exports, "shouldDisableAutoInstrumentation", function () { return $80bdbd6556022c56$export$34db76d03eb96b7e; });

var $9NUbC = parcelRequire("9NUbC");
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ function $80bdbd6556022c56$export$34db76d03eb96b7e(getCurrentHub) {
    const clientOptions = (0, $9NUbC._optionalChain)([
        getCurrentHub,
        "call",
        (_)=>_(),
        "access",
        (_2)=>_2.getClient,
        "call",
        (_3)=>_3(),
        "optionalAccess",
        (_4)=>_4.getOptions,
        "call",
        (_5)=>_5()
    ]);
    const instrumenter = (0, $9NUbC._optionalChain)([
        clientOptions,
        "optionalAccess",
        (_6)=>_6.instrumenter
    ]) || "sentry";
    return instrumenter !== "sentry";
}

});


parcelRegister("cumZG", function(module, exports) {

$parcel$export(module.exports, "BROWSER_TRACING_INTEGRATION_ID", function () { return $0258aded41c44599$export$bbd2089f30bd3708; });
$parcel$export(module.exports, "BrowserTracing", function () { return $0258aded41c44599$export$46d3bbd0375f5fa4; });

var $hpBQ7 = parcelRequire("hpBQ7");
var $iJuzX = parcelRequire("iJuzX");
var $25Qdw = parcelRequire("25Qdw");

var $22Zmp = parcelRequire("22Zmp");
var $d6uqj = parcelRequire("d6uqj");
var $4jmKj = parcelRequire("4jmKj");

var $fc9Bp = parcelRequire("fc9Bp");

var $6P5en = parcelRequire("6P5en");

var $eZNqW = parcelRequire("eZNqW");

var $ab3c2 = parcelRequire("ab3c2");

var $5jEVf = parcelRequire("5jEVf");
const $0258aded41c44599$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $0258aded41c44599$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $25Qdw.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $ab3c2.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $eZNqW.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $0258aded41c44599$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ constructor(_options){
        this.name = $0258aded41c44599$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $hpBQ7.addTracingExtensions)();
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$0258aded41c44599$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $6P5en.startTrackingWebVitals)();
        if (this.options.enableLongTask) (0, $6P5en.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $6P5en.startTrackingInteractions)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $d6uqj.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $fc9Bp.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $eZNqW.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        const sentryTrace = isPageloadTransaction ? $0258aded41c44599$export$f147b32b03c9cf11("sentry-trace") : "";
        const baggage = isPageloadTransaction ? $0258aded41c44599$export$f147b32b03c9cf11("baggage") : "";
        const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $4jmKj.tracingContextFromHeaders)(sentryTrace, baggage);
        const expandedContext = {
            ...context,
            ...traceparentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $5jEVf.WINDOW);
        const idleTransaction = (0, $hpBQ7.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        const scope = hub.getScope();
        // If it's a pageload and there is a meta tag set
        // use the traceparentData as the propagation context
        if (isPageloadTransaction && traceparentData) scope.setPropagationContext(propagationContext);
        else // Navigation transactions should set a new propagation context based on the
        // created idle transaction.
        scope.setPropagationContext({
            traceId: idleTransaction.traceId,
            spanId: idleTransaction.spanId,
            parentSpanId: idleTransaction.parentSpanId,
            sampled: idleTransaction.sampled
        });
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $6P5en.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            const currentTransaction = (0, $iJuzX.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $5jEVf.WINDOW);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || "url"
                }
            };
            inflightInteractionTransaction = (0, $hpBQ7.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $0258aded41c44599$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $22Zmp.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}

});
parcelRegister("fc9Bp", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $b0ff6cd01b51cde5$export$6f18f55521af71a1; });

var $iJuzX = parcelRequire("iJuzX");

var $d6uqj = parcelRequire("d6uqj");

var $5jEVf = parcelRequire("5jEVf");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $b0ff6cd01b51cde5$export$6f18f55521af71a1() {
    if ((0, $5jEVf.WINDOW) && (0, $5jEVf.WINDOW).document) (0, $5jEVf.WINDOW).document.addEventListener("visibilitychange", ()=>{
        const activeTransaction = (0, $iJuzX.getActiveTransaction)();
        if ((0, $5jEVf.WINDOW).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

});
parcelRegister("5jEVf", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $3dee7866cd17a8c9$export$56d8a8a25bd48b81; });

var $gnne5 = parcelRequire("gnne5");
const $3dee7866cd17a8c9$export$56d8a8a25bd48b81 = (0, $gnne5.GLOBAL_OBJ);

});


parcelRegister("6P5en", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", function () { return $4f7b90385d94d89f$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $4f7b90385d94d89f$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $4f7b90385d94d89f$export$e27543e0976315e4; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $4f7b90385d94d89f$export$5f8fa6b3467a7443; });

var $iJuzX = parcelRequire("iJuzX");

var $9rjmL = parcelRequire("9rjmL");
var $22Zmp = parcelRequire("22Zmp");
var $d6uqj = parcelRequire("d6uqj");

var $5jEVf = parcelRequire("5jEVf");

var $9Y4no = parcelRequire("9Y4no");

var $br3GV = parcelRequire("br3GV");

var $aKvJo = parcelRequire("aKvJo");

var $83eTr = parcelRequire("83eTr");

var $jsBRh = parcelRequire("jsBRh");

var $adgRs = parcelRequire("adgRs");
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $4f7b90385d94d89f$var$msToSec(time) {
    return time / 1000;
}
function $4f7b90385d94d89f$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $5jEVf.WINDOW) && (0, $5jEVf.WINDOW).addEventListener && (0, $5jEVf.WINDOW).performance;
}
let $4f7b90385d94d89f$var$_performanceCursor = 0;
let $4f7b90385d94d89f$var$_measurements = {};
let $4f7b90385d94d89f$var$_lcpEntry;
let $4f7b90385d94d89f$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $4f7b90385d94d89f$export$7c69f0412d101b88() {
    const performance = $4f7b90385d94d89f$var$getBrowserPerformanceAPI();
    if (performance && (0, $9rjmL.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $5jEVf.WINDOW).performance.mark("sentry-tracing-init");
        $4f7b90385d94d89f$var$_trackFID();
        const clsCallback = $4f7b90385d94d89f$var$_trackCLS();
        const lcpCallback = $4f7b90385d94d89f$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4f7b90385d94d89f$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $iJuzX.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $4f7b90385d94d89f$var$msToSec((0, $9rjmL.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $4f7b90385d94d89f$var$msToSec(entry.duration);
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $jsBRh.observe)("longtask", entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $4f7b90385d94d89f$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $iJuzX.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $4f7b90385d94d89f$var$msToSec((0, $9rjmL.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $4f7b90385d94d89f$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $22Zmp.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $jsBRh.observe)("event", entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $4f7b90385d94d89f$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $9Y4no.onCLS)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding CLS");
        $4f7b90385d94d89f$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $4f7b90385d94d89f$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4f7b90385d94d89f$var$_trackLCP() {
    return (0, $aKvJo.onLCP)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding LCP");
        $4f7b90385d94d89f$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4f7b90385d94d89f$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $4f7b90385d94d89f$var$_trackFID() {
    (0, $br3GV.onFID)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $4f7b90385d94d89f$var$msToSec((0, $9rjmL.browserPerformanceTimeOrigin));
        const startTime = $4f7b90385d94d89f$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding FID");
        $4f7b90385d94d89f$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4f7b90385d94d89f$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $4f7b90385d94d89f$export$5f8fa6b3467a7443(transaction) {
    const performance = $4f7b90385d94d89f$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $5jEVf.WINDOW).performance.getEntries || !(0, $9rjmL.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $4f7b90385d94d89f$var$msToSec((0, $9rjmL.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($4f7b90385d94d89f$var$_performanceCursor).forEach((entry)=>{
        const startTime = $4f7b90385d94d89f$var$msToSec(entry.startTime);
        const duration = $4f7b90385d94d89f$var$msToSec(entry.duration);
        if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case "navigation":
                $4f7b90385d94d89f$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $4f7b90385d94d89f$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $4f7b90385d94d89f$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $4f7b90385d94d89f$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $83eTr.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding FP");
                        $4f7b90385d94d89f$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding FCP");
                        $4f7b90385d94d89f$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    const resourceName = entry.name.replace((0, $5jEVf.WINDOW).location.origin, "");
                    $4f7b90385d94d89f$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $4f7b90385d94d89f$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4f7b90385d94d89f$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number") {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding TTFB");
            $4f7b90385d94d89f$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $4f7b90385d94d89f$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$4f7b90385d94d89f$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $4f7b90385d94d89f$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $4f7b90385d94d89f$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $4f7b90385d94d89f$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $4f7b90385d94d89f$var$_measurements["mark.fid"];
        if (fidMark && $4f7b90385d94d89f$var$_measurements["fid"]) {
            // create span for FID
            (0, $adgRs._startChild)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $4f7b90385d94d89f$var$msToSec($4f7b90385d94d89f$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4f7b90385d94d89f$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $4f7b90385d94d89f$var$_measurements)) delete $4f7b90385d94d89f$var$_measurements.cls;
        Object.keys($4f7b90385d94d89f$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $4f7b90385d94d89f$var$_measurements[measurementName].value, $4f7b90385d94d89f$var$_measurements[measurementName].unit);
        });
        $4f7b90385d94d89f$var$_tagMetricInfo(transaction);
    }
    $4f7b90385d94d89f$var$_lcpEntry = undefined;
    $4f7b90385d94d89f$var$_clsEntry = undefined;
    $4f7b90385d94d89f$var$_measurements = {};
}
/** Create measure related spans */ function $4f7b90385d94d89f$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $adgRs._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4f7b90385d94d89f$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $4f7b90385d94d89f$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $4f7b90385d94d89f$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $4f7b90385d94d89f$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $4f7b90385d94d89f$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $4f7b90385d94d89f$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4f7b90385d94d89f$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $adgRs._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $4f7b90385d94d89f$var$msToSec(start),
        endTimestamp: timeOrigin + $4f7b90385d94d89f$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4f7b90385d94d89f$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $adgRs._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "request",
        startTimestamp: timeOrigin + $4f7b90385d94d89f$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $4f7b90385d94d89f$var$msToSec(entry.responseEnd)
    });
    (0, $adgRs._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "response",
        startTimestamp: timeOrigin + $4f7b90385d94d89f$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $4f7b90385d94d89f$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $4f7b90385d94d89f$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ("transferSize" in entry) data["http.response_transfer_size"] = entry.transferSize;
    if ("encodedBodySize" in entry) data["http.response_content_length"] = entry.encodedBodySize;
    if ("decodedBodySize" in entry) data["http.decoded_response_content_length"] = entry.decodedBodySize;
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $adgRs._startChild)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $4f7b90385d94d89f$var$_trackNavigator(transaction) {
    const navigator = (0, $5jEVf.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) transaction.setTag("connectionType", connection.type);
        if ((0, $adgRs.isMeasurementValue)(connection.rtt)) $4f7b90385d94d89f$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $adgRs.isMeasurementValue)(navigator.deviceMemory)) transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $adgRs.isMeasurementValue)(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $4f7b90385d94d89f$var$_tagMetricInfo(transaction) {
    if ($4f7b90385d94d89f$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4f7b90385d94d89f$var$_lcpEntry.element) transaction.setTag("lcp.element", (0, $22Zmp.htmlTreeAsString)($4f7b90385d94d89f$var$_lcpEntry.element));
        if ($4f7b90385d94d89f$var$_lcpEntry.id) transaction.setTag("lcp.id", $4f7b90385d94d89f$var$_lcpEntry.id);
        if ($4f7b90385d94d89f$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag("lcp.url", $4f7b90385d94d89f$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag("lcp.size", $4f7b90385d94d89f$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4f7b90385d94d89f$var$_clsEntry && $4f7b90385d94d89f$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("[Measurements] Adding CLS Data");
        $4f7b90385d94d89f$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $22Zmp.htmlTreeAsString)(source.node)));
    }
}

});
parcelRegister("9Y4no", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $741d1cb563a7fab2$export$a7873055838e5ad8; });

var $1rYH9 = parcelRequire("1rYH9");

var $2mMcF = parcelRequire("2mMcF");

var $jsBRh = parcelRequire("jsBRh");

var $4T2pt = parcelRequire("4T2pt");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $741d1cb563a7fab2$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $2mMcF.initMetric)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $jsBRh.observe)("layout-shift", handleEntries);
    if (po) {
        report = (0, $1rYH9.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $4T2pt.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("1rYH9", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $10e764d25a77fc49$export$17679dccdd551979; });
const $10e764d25a77fc49$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("2mMcF", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $1b93070b10f0cc4f$export$3c29b44508a0612b; });

var $5jEVf = parcelRequire("5jEVf");

var $4GY19 = parcelRequire("4GY19");

var $7I08x = parcelRequire("7I08x");

var $1HKu2 = parcelRequire("1HKu2");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1b93070b10f0cc4f$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $1HKu2.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $5jEVf.WINDOW).document.prerendering || (0, $7I08x.getActivationStart)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $4GY19.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("4GY19", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $36a9a3ec7041c24b$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $36a9a3ec7041c24b$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("7I08x", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $59ccbf9c151dc39c$export$d3e828b3c7b5b845; });

var $1HKu2 = parcelRequire("1HKu2");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $59ccbf9c151dc39c$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $1HKu2.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("1HKu2", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $13dddd3b717cb9e8$export$6431553786c94949; });

var $5jEVf = parcelRequire("5jEVf");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $13dddd3b717cb9e8$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $5jEVf.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $5jEVf.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $13dddd3b717cb9e8$export$6431553786c94949 = ()=>{
    if ((0, $5jEVf.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $5jEVf.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $13dddd3b717cb9e8$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $5jEVf.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

});



parcelRegister("jsBRh", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $e2adffb6d589af12$export$d1203567a167490e; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $e2adffb6d589af12$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("4T2pt", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $38ee2b06c9acdf93$export$91ec2be6fdd8f1b4; });

var $5jEVf = parcelRequire("5jEVf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $38ee2b06c9acdf93$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $5jEVf.WINDOW).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};

});


parcelRegister("br3GV", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $853514584dd27065$export$39705a25c49af873; });

var $1rYH9 = parcelRequire("1rYH9");

var $83eTr = parcelRequire("83eTr");

var $2mMcF = parcelRequire("2mMcF");

var $jsBRh = parcelRequire("jsBRh");

var $4T2pt = parcelRequire("4T2pt");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $853514584dd27065$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $83eTr.getVisibilityWatcher)();
    const metric = (0, $2mMcF.initMetric)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $jsBRh.observe)("first-input", handleEntries);
    report = (0, $1rYH9.bindReporter)(onReport, metric);
    if (po) (0, $4T2pt.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("83eTr", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $5dca2801d923fb8b$export$443f86b2c77012c4; });

var $5jEVf = parcelRequire("5jEVf");

var $4T2pt = parcelRequire("4T2pt");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5dca2801d923fb8b$var$firstHiddenTime = -1;
const $5dca2801d923fb8b$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $5jEVf.WINDOW).document.visibilityState === "hidden" && !(0, $5jEVf.WINDOW).document.prerendering ? 0 : Infinity;
};
const $5dca2801d923fb8b$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $4T2pt.onHidden)(({ timeStamp: timeStamp })=>{
        $5dca2801d923fb8b$var$firstHiddenTime = timeStamp;
    }, true);
};
const $5dca2801d923fb8b$export$443f86b2c77012c4 = ()=>{
    if ($5dca2801d923fb8b$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $5dca2801d923fb8b$var$firstHiddenTime = $5dca2801d923fb8b$var$initHiddenTime();
        $5dca2801d923fb8b$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $5dca2801d923fb8b$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("aKvJo", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $7d36d069fe557517$export$947b1626ab8d5632; });

var $1rYH9 = parcelRequire("1rYH9");

var $7I08x = parcelRequire("7I08x");

var $83eTr = parcelRequire("83eTr");

var $2mMcF = parcelRequire("2mMcF");

var $jsBRh = parcelRequire("jsBRh");

var $4T2pt = parcelRequire("4T2pt");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7d36d069fe557517$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $7d36d069fe557517$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $83eTr.getVisibilityWatcher)();
    const metric = (0, $2mMcF.initMetric)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $7I08x.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $jsBRh.observe)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $1rYH9.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$7d36d069fe557517$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $7d36d069fe557517$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $4T2pt.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("adgRs", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", function () { return $76f8328a9f4c2804$export$27169ccae1b439e3; });
$parcel$export(module.exports, "_startChild", function () { return $76f8328a9f4c2804$export$8bd469e1f37aa721; });
/**
 * Checks if a given value is a valid measurement value.
 */ function $76f8328a9f4c2804$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $76f8328a9f4c2804$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("eZNqW", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $aead1bb040830aef$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $aead1bb040830aef$export$864489cb3478db3e; });

var $qxdOb = parcelRequire("qxdOb");
var $kxUsJ = parcelRequire("kxUsJ");
var $6oOQO = parcelRequire("6oOQO");

var $a4dim = parcelRequire("a4dim");
var $i0l4v = parcelRequire("i0l4v");
var $9rjmL = parcelRequire("9rjmL");
var $4jmKj = parcelRequire("4jmKj");
var $f6lSX = parcelRequire("f6lSX");
var $gPyQa = parcelRequire("gPyQa");
/* eslint-disable max-lines */ const $aead1bb040830aef$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $aead1bb040830aef$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $aead1bb040830aef$export$15bd0305d05ad07b,
    tracePropagationTargets: $aead1bb040830aef$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $aead1bb040830aef$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $aead1bb040830aef$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $aead1bb040830aef$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$aead1bb040830aef$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $a4dim.addInstrumentationHandler)("fetch", (handlerData)=>{
        const createdSpan = $aead1bb040830aef$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $aead1bb040830aef$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $a4dim.addInstrumentationHandler)("xhr", (handlerData)=>{
        const createdSpan = $aead1bb040830aef$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $aead1bb040830aef$var$addHTTPTimings(createdSpan);
    });
}
function $aead1bb040830aef$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $aead1bb040830aef$var$addHTTPTimings(span) {
    const url = span.data.url;
    const observer = new PerformanceObserver((list)=>{
        const entries = list.getEntries();
        entries.forEach((entry)=>{
            if ($aead1bb040830aef$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $aead1bb040830aef$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setData(...data));
                observer.disconnect();
            }
        });
    });
    observer.observe({
        entryTypes: [
            "resource"
        ]
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $aead1bb040830aef$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $aead1bb040830aef$var$getAbsoluteTime(time = 0) {
    return (((0, $9rjmL.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $aead1bb040830aef$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $aead1bb040830aef$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $9rjmL.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $aead1bb040830aef$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $aead1bb040830aef$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $gPyQa.stringMatchesSomePattern)(url, tracePropagationTargets || $aead1bb040830aef$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $aead1bb040830aef$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $6oOQO.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
                const contentLength = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                const contentLengthNum = parseInt(contentLength);
                if (contentLengthNum > 0) span.setData("http.response_content_length", contentLengthNum);
            } else if (handlerData.error) span.setStatus("internal_error");
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $qxdOb.getCurrentHub)();
    const scope = hub.getScope();
    const client = hub.getClient();
    const parentSpan = scope.getSpan();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            url: url,
            type: "fetch",
            "http.method": method
        },
        description: `${method} ${url}`,
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $aead1bb040830aef$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $aead1bb040830aef$export$6717acf674206871(request, client, scope, options, requestSpan) {
    const span = requestSpan || scope.getSpan();
    const transaction = span && span.transaction;
    const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
    const sentryTraceHeader = span ? span.toTraceparent() : (0, $4jmKj.generateSentryTraceHeader)(traceId, undefined, sampled);
    const dynamicSamplingContext = transaction ? transaction.getDynamicSamplingContext() : dsc ? dsc : (0, $kxUsJ.getDynamicSamplingContextFromClient)(traceId, client, scope);
    const sentryBaggageHeader = (0, $i0l4v.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
    const headers = typeof Request !== "undefined" && (0, $f6lSX.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $f6lSX.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $i0l4v.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $i0l4v.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $aead1bb040830aef$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $a4dim.SENTRY_XHR_DATA_KEY];
    if (!(0, $6oOQO.hasTracingEnabled)() || xhr && xhr.__sentry_own_request__ || !xhr || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $qxdOb.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            ...sentryXhrData.data,
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url
        },
        description: `${sentryXhrData.method} ${sentryXhrData.url}`,
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
        if (span) {
            const transaction = span && span.transaction;
            const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $i0l4v.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            $aead1bb040830aef$var$setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
        } else {
            const client = hub.getClient();
            const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
            const sentryTraceHeader = (0, $4jmKj.generateSentryTraceHeader)(traceId, undefined, sampled);
            const dynamicSamplingContext = dsc || (client ? (0, $kxUsJ.getDynamicSamplingContextFromClient)(traceId, client, scope) : undefined);
            const sentryBaggageHeader = (0, $i0l4v.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            $aead1bb040830aef$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
        }
    }
    return span;
}
function $aead1bb040830aef$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $i0l4v.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}

});

parcelRegister("ab3c2", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", function () { return $768d68908663c0bd$export$86649cc09fe75143; });

var $a4dim = parcelRequire("a4dim");
var $9rjmL = parcelRequire("9rjmL");
var $d6uqj = parcelRequire("d6uqj");

var $5jEVf = parcelRequire("5jEVf");
/**
 * Default function implementing pageload and navigation transactions
 */ function $768d68908663c0bd$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $5jEVf.WINDOW) || !(0, $5jEVf.WINDOW).location) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $5jEVf.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $5jEVf.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $9rjmL.browserPerformanceTimeOrigin) ? (0, $9rjmL.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $a4dim.addInstrumentationHandler)("history", ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $5jEVf.WINDOW).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}

});


parcelRegister("9NpO5", function(module, exports) {

$parcel$export(module.exports, "Express", function () { return $721cb55fc0c09bc2$export$6dafdd8fec05099d; });

var $9NUbC = parcelRequire("9NUbC");

var $dYsTP = parcelRequire("dYsTP");
var $d4hcq = parcelRequire("d4hcq");
var $f6lSX = parcelRequire("f6lSX");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $721cb55fc0c09bc2$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Express";
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $721cb55fc0c09bc2$export$6dafdd8fec05099d.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat("use");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("ExpressIntegration is missing an Express instance");
            return;
        }
        if ((0, $b3hKh.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("Express Integration is skipped because of instrumenter configuration.");
            return;
        }
        $721cb55fc0c09bc2$var$instrumentMiddlewares(this._router, this._methods);
        $721cb55fc0c09bc2$var$instrumentRouter(this._router);
    }
}
$721cb55fc0c09bc2$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $721cb55fc0c09bc2$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: "auto.middleware.express"
                    });
                    res.once("finish", ()=>{
                        span.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $9NUbC._optionalChain)([
                    transaction,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_4)=>_4.finish,
                        "call",
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $9NUbC._optionalChain)([
                    transaction,
                    "optionalAccess",
                    (_6)=>_6.startChild,
                    "call",
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $721cb55fc0c09bc2$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === "function") return $721cb55fc0c09bc2$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === "function") return $721cb55fc0c09bc2$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $721cb55fc0c09bc2$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$721cb55fc0c09bc2$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $721cb55fc0c09bc2$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$721cb55fc0c09bc2$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $721cb55fc0c09bc2$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = "settings" in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).debug("Cannot instrument router for URL Parameterization (did not find a valid router).");
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).debug("Routing instrumentation is currently only supported in Express 4.");
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = "";
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $721cb55fc0c09bc2$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        const partialRoute = layerRoutePath || layer.path || "";
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split("/").filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes("*"))).join("/");
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? "/" : ""}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $d4hcq.getNumberOfUrlSegments)(req.originalUrl || "") + numExtraSegments;
        const routeLength = (0, $d4hcq.getNumberOfUrlSegments)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $d4hcq.stripUrlQueryAndFragment)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            if (transaction && transaction.metadata.source !== "custom") {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || "/";
                transaction.setName(...(0, $dYsTP.extractPathForTransaction)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }));
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $721cb55fc0c09bc2$var$getLayerRoutePathInfo(layer) {
    const lrp = (0, $9NUbC._optionalChain)([
        layer,
        "access",
        (_10)=>_10.route,
        "optionalAccess",
        (_11)=>_11.path
    ]);
    const isRegex = (0, $f6lSX.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($721cb55fc0c09bc2$var$getNumberOfArrayUrlSegments(lrp) - (0, $d4hcq.getNumberOfUrlSegments)(layer.path || ""), 0) : 0;
    const layerRoutePath = $721cb55fc0c09bc2$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $721cb55fc0c09bc2$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $d4hcq.getNumberOfUrlSegments)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $721cb55fc0c09bc2$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(",");
    return lrp && lrp.toString();
}

});
parcelRegister("dYsTP", function(module, exports) {

$parcel$export(module.exports, "extractPathForTransaction", function () { return $a2c74bc38f1a1bfa$export$8c5ebee2e5bb9575; });

var $f6lSX = parcelRequire("f6lSX");

var $6GXn2 = parcelRequire("6GXn2");

var $d4hcq = parcelRequire("d4hcq");
const $a2c74bc38f1a1bfa$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $a2c74bc38f1a1bfa$var$DEFAULT_REQUEST_INCLUDES = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
const $a2c74bc38f1a1bfa$var$DEFAULT_USER_INCLUDES = [
    "id",
    "username",
    "email"
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request
 */ function $a2c74bc38f1a1bfa$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    if (!transaction.metadata.source || transaction.metadata.source === "url") // Attempt to grab a parameterized route off of the request
    transaction.setName(...$a2c74bc38f1a1bfa$export$8c5ebee2e5bb9575(req, {
        path: true,
        method: true
    }));
    transaction.setData("url", req.originalUrl || req.url);
    if (req.baseUrl) transaction.setData("baseUrl", req.baseUrl);
    transaction.setData("query", $a2c74bc38f1a1bfa$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $a2c74bc38f1a1bfa$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = "";
    let source = "url";
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ""}${req.route && req.route.path}`;
        source = "route";
    } else if (req.originalUrl || req.url) path = (0, $d4hcq.stripUrlQueryAndFragment)(req.originalUrl || req.url || "");
    let name = "";
    if (options.method && method) name += method;
    if (options.method && options.path) name += " ";
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $a2c74bc38f1a1bfa$var$extractTransaction(req, type) {
    switch(type){
        case "path":
            return $a2c74bc38f1a1bfa$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case "handler":
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || "<anonymous>";
        case "methodPath":
        default:
            return $a2c74bc38f1a1bfa$export$8c5ebee2e5bb9575(req, {
                path: true,
                method: true
            })[0];
    }
}
/** JSDoc */ function $a2c74bc38f1a1bfa$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $a2c74bc38f1a1bfa$var$DEFAULT_USER_INCLUDES;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $a2c74bc38f1a1bfa$export$b5c5d78255f11c84(req, options) {
    const { include: include = $a2c74bc38f1a1bfa$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    const host = req.hostname || req.host || headers.host || "<no host>";
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === "https" || req.socket && req.socket.encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || "";
    // absolute url
    const absoluteUrl = `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case "headers":
                requestData.headers = headers;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && deps && deps.cookie && deps.cookie.parse(headers.cookie) || {};
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $a2c74bc38f1a1bfa$var$extractQueryParams(req, deps);
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $f6lSX.isString)(req.body) ? req.body : JSON.stringify((0, $6GXn2.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Options deciding what parts of the request to use when enhancing an event
 */ /**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @hidden
 */ function $a2c74bc38f1a1bfa$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$a2c74bc38f1a1bfa$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $a2c74bc38f1a1bfa$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $a2c74bc38f1a1bfa$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $f6lSX.isPlainObject)(req.user) ? $a2c74bc38f1a1bfa$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $a2c74bc38f1a1bfa$var$extractTransaction(req, include.transaction);
    return event;
}
function $a2c74bc38f1a1bfa$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || "";
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith("/")) originalUrl = `http://dogs.are.great${originalUrl}`;
    return req.query || new URL(originalUrl).search.replace("?", "") || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
    deps && deps.url && deps.url.parse(originalUrl).query || undefined;
}

});


parcelRegister("epGyk", function(module, exports) {

$parcel$export(module.exports, "GraphQL", function () { return $a7e4688b0fe23da2$export$b735d011553f1049; });

var $9NUbC = parcelRequire("9NUbC");

var $btSxb = parcelRequire("btSxb");
var $f6lSX = parcelRequire("f6lSX");
var $1ZrrS = parcelRequire("1ZrrS");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
/** Tracing integration for graphql package */ class $a7e4688b0fe23da2$export$b735d011553f1049 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GraphQL";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $a7e4688b0fe23da2$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $1ZrrS.loadModule)("graphql/execution/execute.js");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $b3hKh.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("GraphQL Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("GraphQL Integration was unable to require graphql/execution package.");
            return;
        }
        (0, $btSxb.fill)(pkg, "execute", function(orig) {
            return function(...args) {
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                const span = (0, $9NUbC._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: "execute",
                            op: "graphql.execute",
                            origin: "auto.graphql.graphql"
                        })
                ]);
                (0, $9NUbC._optionalChain)([
                    scope,
                    "optionalAccess",
                    (_4)=>_4.setSpan,
                    "call",
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $f6lSX.isThenable)(rv)) return rv.then((res)=>{
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.finish,
                        "call",
                        (_7)=>_7()
                    ]);
                    (0, $9NUbC._optionalChain)([
                        scope,
                        "optionalAccess",
                        (_8)=>_8.setSpan,
                        "call",
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, $9NUbC._optionalChain)([
                    span,
                    "optionalAccess",
                    (_10)=>_10.finish,
                    "call",
                    (_11)=>_11()
                ]);
                (0, $9NUbC._optionalChain)([
                    scope,
                    "optionalAccess",
                    (_12)=>_12.setSpan,
                    "call",
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$a7e4688b0fe23da2$export$b735d011553f1049.__initStatic();

});

parcelRegister("lWUU2", function(module, exports) {

$parcel$export(module.exports, "Mongo", function () { return $ffab27777ee30c51$export$968aa4360b02a334; });

var $9NUbC = parcelRequire("9NUbC");

var $btSxb = parcelRequire("btSxb");
var $f6lSX = parcelRequire("f6lSX");
var $1ZrrS = parcelRequire("1ZrrS");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $ffab27777ee30c51$var$OPERATIONS = [
    "aggregate",
    "bulkWrite",
    "countDocuments",
    "createIndex",
    "createIndexes",
    "deleteMany",
    "deleteOne",
    "distinct",
    "drop",
    "dropIndex",
    "dropIndexes",
    "estimatedDocumentCount",
    "find",
    "findOne",
    "findOneAndDelete",
    "findOneAndReplace",
    "findOneAndUpdate",
    "indexes",
    "indexExists",
    "indexInformation",
    "initializeOrderedBulkOp",
    "insertMany",
    "insertOne",
    "isCapped",
    "mapReduce",
    "options",
    "parallelCollectionScan",
    "rename",
    "replaceOne",
    "stats",
    "updateMany",
    "updateOne"
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $ffab27777ee30c51$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        "operations"
    ],
    countDocuments: [
        "query"
    ],
    createIndex: [
        "fieldOrSpec"
    ],
    createIndexes: [
        "indexSpecs"
    ],
    deleteMany: [
        "filter"
    ],
    deleteOne: [
        "filter"
    ],
    distinct: [
        "key",
        "query"
    ],
    dropIndex: [
        "indexName"
    ],
    find: [
        "query"
    ],
    findOne: [
        "query"
    ],
    findOneAndDelete: [
        "filter"
    ],
    findOneAndReplace: [
        "filter",
        "replacement"
    ],
    findOneAndUpdate: [
        "filter",
        "update"
    ],
    indexExists: [
        "indexes"
    ],
    insertMany: [
        "docs"
    ],
    insertOne: [
        "doc"
    ],
    mapReduce: [
        "map",
        "reduce"
    ],
    rename: [
        "newName"
    ],
    replaceOne: [
        "filter",
        "doc"
    ],
    updateMany: [
        "filter",
        "update"
    ],
    updateOne: [
        "filter",
        "update"
    ]
};
function $ffab27777ee30c51$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === "object" && maybeCursor.once && typeof maybeCursor.once === "function";
}
/** Tracing integration for mongo package */ class $ffab27777ee30c51$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mongo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $ffab27777ee30c51$export$968aa4360b02a334.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $ffab27777ee30c51$var$OPERATIONS;
        this._describeOperations = "describeOperations" in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? "mongoose" : "mongodb";
        return this._module = this._module || (0, $1ZrrS.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $b3hKh.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("Mongo Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? "mongoose" : "mongodb";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $btSxb.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== "function" || operation === "mapReduce" && args.length === 2) {
                    const span = (0, $9NUbC._optionalChain)([
                        parentSpan,
                        "optionalAccess",
                        (_2)=>_2.startChild,
                        "call",
                        (_3)=>_3(getSpanContext(this, operation, args))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $f6lSX.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $9NUbC._optionalChain)([
                            span,
                            "optionalAccess",
                            (_4)=>_4.finish,
                            "call",
                            (_5)=>_5()
                        ]);
                        return res;
                    });
                    else if ($ffab27777ee30c51$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once("close", ()=>{
                                (0, $9NUbC._optionalChain)([
                                    span,
                                    "optionalAccess",
                                    (_6)=>_6.finish,
                                    "call",
                                    (_7)=>_7()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $9NUbC._optionalChain)([
                                span,
                                "optionalAccess",
                                (_8)=>_8.finish,
                                "call",
                                (_9)=>_9()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $9NUbC._optionalChain)([
                            span,
                            "optionalAccess",
                            (_10)=>_10.finish,
                            "call",
                            (_11)=>_11()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                const span = (0, $9NUbC._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_12)=>_12.startChild,
                    "call",
                    (_13)=>_13(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_14)=>_14.finish,
                        "call",
                        (_15)=>_15()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args) {
        const data = {
            "db.system": "mongodb",
            "db.name": collection.dbName,
            "db.operation": operation,
            "db.mongodb.collection": collection.collectionName
        };
        const spanContext = {
            op: "db",
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: "auto.db.mongo",
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $ffab27777ee30c51$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === "mapReduce") {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === "string" ? map : map.name || "<anonymous>";
                data[signature[1]] = typeof reduce === "string" ? reduce : reduce.name || "<anonymous>";
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$ffab27777ee30c51$export$968aa4360b02a334.__initStatic();

});

parcelRegister("dud9P", function(module, exports) {

$parcel$export(module.exports, "Mysql", function () { return $9d184883e657d465$export$a2cc26ff91a3f8ad; });

var $9NUbC = parcelRequire("9NUbC");

var $btSxb = parcelRequire("btSxb");
var $1ZrrS = parcelRequire("1ZrrS");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
/** Tracing integration for node-mysql package */ class $9d184883e657d465$export$a2cc26ff91a3f8ad {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mysql";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $9d184883e657d465$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $1ZrrS.loadModule)("mysql/lib/Connection.js");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $b3hKh.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("Mysql Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("Mysql Integration was unable to require `mysql` package.");
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("Mysql Integration was unable to instrument `mysql` config.");
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                "server.address": mySqlConfig.host,
                "server.port": mySqlConfig.port,
                "db.user": mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setData(key, data[key]);
            });
            span.finish();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $btSxb.fill)(pkg, "createQuery", function(orig) {
            return function(options, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                const span = (0, $9NUbC._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: typeof options === "string" ? options : options.sql,
                            op: "db",
                            origin: "auto.db.mysql",
                            data: {
                                "db.system": "mysql"
                            }
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === "function") return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                return orig.call(this, options, values, function() {
                    finishSpan(span);
                });
            };
        });
    }
}
$9d184883e657d465$export$a2cc26ff91a3f8ad.__initStatic();

});

parcelRegister("bDAMw", function(module, exports) {

$parcel$export(module.exports, "Postgres", function () { return $878fde496afac245$export$806ddb599177abc4; });

var $9NUbC = parcelRequire("9NUbC");

var $btSxb = parcelRequire("btSxb");
var $f6lSX = parcelRequire("f6lSX");
var $1ZrrS = parcelRequire("1ZrrS");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
/** Tracing integration for node-postgres package */ class $878fde496afac245$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Postgres";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $878fde496afac245$export$806ddb599177abc4.id;
        this._usePgNative = !!options.usePgNative;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $1ZrrS.loadModule)("pg");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $b3hKh.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).log("Postgres Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("Postgres Integration was unable to require `pg` package.");
            return;
        }
        if (this._usePgNative && !(0, $9NUbC._optionalChain)([
            pkg,
            "access",
            (_2)=>_2.native,
            "optionalAccess",
            (_3)=>_3.Client
        ])) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        const { Client: Client } = this._usePgNative ? pkg.native : pkg;
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $btSxb.fill)(Client.prototype, "query", function(orig) {
            return function(config, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = scope.getSpan();
                const data = {
                    "db.system": "postgresql"
                };
                try {
                    if (this.database) data["db.name"] = this.database;
                    if (this.host) data["server.address"] = this.host;
                    if (this.port) data["server.port"] = this.port;
                    if (this.user) data["db.user"] = this.user;
                } catch (e) {
                // ignore
                }
                const span = (0, $9NUbC._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_4)=>_4.startChild,
                    "call",
                    (_5)=>_5({
                            description: typeof config === "string" ? config : config.text,
                            op: "db",
                            origin: "auto.db.postgres",
                            data: data
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, config, values, function(err, result) {
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.finish,
                        "call",
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === "function") return orig.call(this, config, function(err, result) {
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== "undefined" ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $f6lSX.isThenable)(rv)) return rv.then((res)=>{
                    (0, $9NUbC._optionalChain)([
                        span,
                        "optionalAccess",
                        (_10)=>_10.finish,
                        "call",
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, $9NUbC._optionalChain)([
                    span,
                    "optionalAccess",
                    (_12)=>_12.finish,
                    "call",
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
$878fde496afac245$export$806ddb599177abc4.__initStatic();

});

parcelRegister("6uyRZ", function(module, exports) {

$parcel$export(module.exports, "Prisma", function () { return $4ba097d1c55379bc$export$e300e6f4779d55c2; });

var $qxdOb = parcelRequire("qxdOb");
var $7G9cE = parcelRequire("7G9cE");

var $btSxb = parcelRequire("btSxb");
var $d6uqj = parcelRequire("d6uqj");

var $b3hKh = parcelRequire("b3hKh");
function $4ba097d1c55379bc$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient["$use"];
}
/** Tracing integration for @prisma/client package */ class $4ba097d1c55379bc$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Prisma";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $4ba097d1c55379bc$export$e300e6f4779d55c2.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($4ba097d1c55379bc$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $btSxb.addNonEnumerableProperty)(options.client, "_sentryInstrumented", true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider: activeProvider, clientVersion: clientVersion } = engineConfig;
                    if (activeProvider) clientData["db.system"] = activeProvider;
                    if (clientVersion) clientData["db.prisma.version"] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                if ((0, $b3hKh.shouldDisableAutoInstrumentation)((0, $qxdOb.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, $7G9cE.trace)({
                    name: model ? `${model} ${action}` : action,
                    op: "db.sql.prisma",
                    origin: "auto.db.prisma",
                    data: {
                        ...clientData,
                        "db.operation": action
                    }
                }, ()=>next(params));
            });
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $d6uqj.logger).warn("Unsupported Prisma client provided to PrismaIntegration. Provided client:", options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
$4ba097d1c55379bc$export$e300e6f4779d55c2.__initStatic();

});
parcelRegister("7G9cE", function(module, exports) {

$parcel$export(module.exports, "trace", function () { return $597398281e20810d$export$357889f174732d38; });

var $f6lSX = parcelRequire("f6lSX");

var $qxdOb = parcelRequire("qxdOb");

var $6oOQO = parcelRequire("6oOQO");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 */ function $597398281e20810d$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}) {
    const ctx = $597398281e20810d$var$normalizeContext(context);
    const hub = (0, $qxdOb.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = $597398281e20810d$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        onError(e);
        finishAndSetSpan();
        throw e;
    }
    if ((0, $f6lSX.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishAndSetSpan();
    }, (e)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(e);
        finishAndSetSpan();
    });
    else finishAndSetSpan();
    return maybePromiseResult;
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $597398281e20810d$export$a1bd95187356f372(context, callback) {
    const ctx = $597398281e20810d$var$normalizeContext(context);
    const hub = (0, $qxdOb.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = $597398281e20810d$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        finishAndSetSpan();
        throw e;
    }
    if ((0, $f6lSX.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishAndSetSpan();
    }, ()=>{
        activeSpan && activeSpan.setStatus("internal_error");
        finishAndSetSpan();
    });
    else finishAndSetSpan();
    return maybePromiseResult;
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $597398281e20810d$export$cb9e396e6b90b703 = $597398281e20810d$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $597398281e20810d$export$c10292ad04b92aea(context, callback) {
    const ctx = $597398281e20810d$var$normalizeContext(context);
    const hub = (0, $qxdOb.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = $597398281e20810d$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan, finishAndSetSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        throw e;
    }
    if ((0, $f6lSX.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(undefined, ()=>{
        activeSpan && activeSpan.setStatus("internal_error");
    });
    return maybePromiseResult;
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $597398281e20810d$export$63dbba021a6b4047(context) {
    if (!(0, $6oOQO.hasTracingEnabled)()) return undefined;
    const ctx = {
        ...context
    };
    // If a name is set and a description is not, set the description to the name.
    if (ctx.name !== undefined && ctx.description === undefined) ctx.description = ctx.name;
    const hub = (0, $qxdOb.getCurrentHub)();
    const parentSpan = $597398281e20810d$export$1be426a8e585c83e();
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
}
/**
 * Returns the currently active span.
 */ function $597398281e20810d$export$1be426a8e585c83e() {
    return (0, $qxdOb.getCurrentHub)().getScope().getSpan();
}
function $597398281e20810d$var$createChildSpanOrTransaction(hub, parentSpan, ctx) {
    if (!(0, $6oOQO.hasTracingEnabled)()) return undefined;
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
}
function $597398281e20810d$var$normalizeContext(context) {
    const ctx = {
        ...context
    };
    // If a name is set and a description is not, set the description to the name.
    if (ctx.name !== undefined && ctx.description === undefined) ctx.description = ctx.name;
    return ctx;
}

});


parcelRegister("449X2", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", function () { return $2f5f4144a86d22d6$export$beb8e6a823e89c5d; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ // eslint-disable-next-line import/export
var $2f5f4144a86d22d6$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($2f5f4144a86d22d6$export$beb8e6a823e89c5d || ($2f5f4144a86d22d6$export$beb8e6a823e89c5d = {}));

});



//# sourceMappingURL=esm.dd8382cc.js.map
